document.addEventListener('DOMContentLoaded', function() {
  function updateScrollbarWidthValue() {
  	const scrollbarWidth = Math.min(20, Math.ceil(window.innerWidth - document.documentElement.clientWidth)) || 0;
  	document.documentElement.style.setProperty('--DOC-SCROLLBAR-WIDTH', `${scrollbarWidth}px`);
  	return scrollbarWidth;
  }
  
  updateScrollbarWidthValue();

  // Run this again on subsequent changes
  const resizeObserver = new ResizeObserver((entries) => {
    if (!entries[0].target.clientHeight) {
        return;
    }
    const newWidth = updateScrollbarWidthValue();
    if (newWidth >= 10) {
        // Based on this (@link https://codepen.io/sambible/post/browser-scrollbar-widths), a scrollbar over 10px should cover most cases
        resizeObserver.disconnect(); // We've got a significant scrollbar width, no need to look for additional changes
    }
  });
  requestAnimationFrame(function () { resizeObserver.observe(document.body); });

  Array.from(document.querySelectorAll('[data-swipe-enabled]')).forEach(function (gestureZone){
    let touchstartX = 0;
    let touchstartY = 0;
    let touchendX = 0;
    let touchendY = 0;
    
    gestureZone.addEventListener('touchstart', function(event) {
        touchstartX = event.changedTouches[0].screenX;
        touchstartY = event.changedTouches[0].screenY;
    }, false);
    
    gestureZone.addEventListener('touchend', function(event) {
        touchendX = event.changedTouches[0].screenX;
        touchendY = event.changedTouches[0].screenY;
        handleGesture();
    }, false); 
    
    function handleGesture() {
      let moveX = touchendX - touchstartX;
      let moveY = touchendY - touchstartY;
      let deltaX = Math.abs(moveX);
      let deltaY = Math.abs(moveY);
      let thresholdX = 50;

      if (deltaX < deltaY) { return; } // Vertical scroll, discard
      if (moveX === 0 && moveY === 0) { return; } // Tap, discard
      if (deltaX < thresholdX) { return; } // Very little scroll, discard

      let event = new CustomEvent('muse:swipe', {
        bubbles: true,
        detail: {
          swipeX: moveX,
          swipeY: moveY,
          swipeDirection: {
            x: moveX > 0 ? 'right' : 'left',
            y: moveY > 0 ? 'down' : 'up',
          }
        }
      });
      gestureZone.dispatchEvent(event);

      // if (moveX < 0) {
      //     console.log('Swiped left');
      // }
      
      // if (moveX > 0) {
      //     console.log('Swiped right');
      // }
      
      // if (touchendY < touchstartY) {
      //     console.log('Swiped up');
      // }
      
      // if (touchendY > touchstartY) {
      //    console.log('Swiped down');
      // }
    }
  })
});